// 接受邀請（SPEC #org-model-membership）：已有帳號的人點到邀請連結 → 先記下 token，登入後自動 POST /v1/orgs/join。
// token 只放 sessionStorage（關掉分頁就沒了）；不進網址列以外的地方、不進 log。
const KEY = 'kinio.vms.pendingJoin';

export interface PendingJoin {
  token: string;
  env: string;
}

export function savePendingJoin(token: string, env: string): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ token, env }));
  } catch {
    /* 無 storage：使用者要重新點邀請連結 */
  }
}

/** 看一眼（不清掉）：登入頁顯示「登入後會接受邀請」。 */
export function peekPendingJoin(): PendingJoin | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as PendingJoin) : null;
  } catch {
    return null;
  }
}

export function takePendingJoin(): PendingJoin | null {
  const v = peekPendingJoin();
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* 無 storage */
  }
  return v;
}
